import { Component, effect, input, output, signal } from '@angular/core'
import { TextInputComponent } from '../text-input/text-input.component'

@Component({
  selector: 'div[app-number-input]',
  imports: [
    TextInputComponent,
  ],
  styles: '',
  template: `
        <div app-text-input [value]="text()" (valueChange)="text.set($event)" (blur)="reset()"></div>
    `,
})
export class NumberInputComponent {
  public readonly value = input<number>(0)
  public readonly valueChange = output<number>()
  protected readonly text = signal<string>('')

  constructor() {
    effect(() => {
      this.text.set(this.value().toString())
    })

    effect(() => {
      const parsed = parseFloat(this.text())
      if(!Number.isNaN(parsed)) {
        this.valueChange.emit(parsed)
      }
    })
  }

  protected reset() {
    this.text.set(`${this.value()}`)
  }
}